export default defineNuxtPlugin(() => {
  if (process.client) {
    const router = useRouter()

    const scrollElementToTop = (el: Element | null) => {
      if (!el) return false
      const target = el as HTMLElement
      if (typeof (target as any).scrollTo === 'function') {
        target.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      } else {
        target.scrollTop = 0
        target.scrollLeft = 0
      }
      return true
    }

    const doScrollToTop = () => {
      nextTick(() => {
        // 1) 我们显式标记的内容容器
        if (scrollElementToTop(document.querySelector('.scroll-container')))
          return

        // 2) 我们标记的外层容器
        const marked = document.querySelectorAll('[data-scroll-container]')
        if (marked.length > 0) {
          marked.forEach((el) => scrollElementToTop(el))
          return
        }

        // 3) Naive UI 默认内容容器
        const contentEls = document.querySelectorAll(
          '.n-layout-content .n-layout-content__content'
        )
        if (contentEls.length > 0) {
          contentEls.forEach((el) => scrollElementToTop(el))
          return
        }

        // 4) 回退到 window
        try {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        } catch {
          window.scrollTo(0, 0)
        }
      })
    }

    router.afterEach(() => {
      doScrollToTop()
    })
  }
})
